import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Geyser4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.GEYSER4;
}

export default Geyser4PoiTileEntity;
